/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Orgmanagerv1Dependency } from '../models/Orgmanagerv1Dependency';
import { Orgmanagerv1Miscellanea } from '../models/Orgmanagerv1Miscellanea';
import { Orgmanagerv1SystemStat } from '../models/Orgmanagerv1SystemStat';
import { HttpFile } from '../http/http';

export class Orgmanagerv1Checks {
    'systemStat'?: Orgmanagerv1SystemStat;
    'dependencies'?: Array<Orgmanagerv1Dependency>;
    'miscellaneous'?: Array<Orgmanagerv1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Orgmanagerv1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Orgmanagerv1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Orgmanagerv1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Orgmanagerv1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

